const { parseToHsl } = require("polished");

/**
 * Homepage project-card palette derived from a single hue.
 * Saturation / lightness recipes are shared; only hue varies per project.
 *
 * Button model: high-L base states, low-L hover states
 * (so hover never mirrors the other button's default).
 */

const hexToHue = (hex) => Math.round(parseToHsl(hex).hue);

// Hues extracted from existing projectThemes[].title hex values
const PROJECT_HUES = {
  "condexo-pay": hexToHue("#03324F"), // 203
  "condexo-property-management": hexToHue("#0D5C52"), // 172
  "harmindra-international": hexToHue("#1A5276"), // 203
  meltwater: hexToHue("#C54B2A"), // 13
  jiffy: hexToHue("#5A3E7A"), // 268
};

// Static S/L recipes - tune here only
const RECIPE = {
  card: { s: 100, l: 97 },
  // High luminosity base fills / accents
  light: { s: 45, l: 50 },
  // Low luminosity hover fills
  dark: { s: 45, l: 18 },
};

const hsl = (h, s, l) => `hsl(${h}, ${s}%, ${l}%)`;

const getProjectCardColors = (hue) => {
  const card = hsl(hue, RECIPE.card.s, RECIPE.card.l);
  const light = hsl(hue, RECIPE.light.s, RECIPE.light.l);
  const dark = hsl(hue, RECIPE.dark.s, RECIPE.dark.l);

  return {
    card,
    buttons: {
      solid: {
        // Base: high luminosity
        background: light,
        color: "#fff",
        border: light,
        // Hover: low luminosity
        hoverBackground: dark,
        hoverColor: "#fff",
        hoverBorder: dark,
      },
      outlined: {
        // Base: transparent over high-L card, dark accents
        background: "transparent",
        color: dark,
        border: dark,
        // Hover: low luminosity (same shade family as solid hover)
        hoverBackground: dark,
        hoverColor: "#fff",
        hoverBorder: dark,
      },
    },
  };
};

const getProjectCardColorsBySlug = (slug) => {
  const hue = PROJECT_HUES[slug];
  if (hue == null) {
    return getProjectCardColors(PROJECT_HUES["condexo-pay"]);
  }
  return getProjectCardColors(hue);
};

module.exports = {
  hexToHue,
  PROJECT_HUES,
  getProjectCardColors,
  getProjectCardColorsBySlug,
};
